import React, { ReactNode } from "react";
import * as Styled from "./styles";
import { BiSearch } from "react-icons/bi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Spinner from "@components/common/Spinner";
import { useClickOutside } from "@hook/useClickOutside";

interface IInputSelectSearch {
  title: string;
  value: string;
  onChangeInput: React.ChangeEventHandler<HTMLInputElement> | undefined;
  placeholder?: string;
  isSelected?: string;
  height?: string;
  width?: string;
  disabled?: boolean;
  isRequirement?: boolean;
  onChangeIcon: React.MouseEventHandler<SVGElement>;
  onClickSearchIcon: () => void;
  loading?: boolean;
  children?: ReactNode;
  isOportunity?: boolean;
  searchOnClick?: boolean;
}

const InputSelectSearch = ({
  title,
  value,
  onChangeInput,
  placeholder,
  isSelected,
  height,
  width,
  disabled,
  isRequirement,
  onChangeIcon,
  onClickSearchIcon,
  loading,
  children,
  isOportunity,
  searchOnClick = false
}: IInputSelectSearch) => {
  const wrapperRef: any = React.useRef(null);
  const [open, setOpen] = React.useState<boolean>(false);

  useClickOutside(wrapperRef, () => {
    setOpen(false);
  });

  React.useEffect(() => {
    if (isSelected) {
      setOpen(false);
    }
  }, [isSelected]);

  const handleSearchIconClick = () => {
    if (selectedOption) {
      setSelectedOption(null);
    } else {
      setOpen(!open);
      onClickSearchIcon();
    }
  };

  const [selectedOption, setSelectedOption] = React.useState<string | null>(
    null
  );

  return (
    <Styled.Container ref={wrapperRef}>
      <Styled.Label>
        {isRequirement && <Styled.Requirement>*</Styled.Requirement>}
        {title}
      </Styled.Label>
      <Styled.SelectButton disabled={disabled}>
        <Styled.InputText
          disabled={disabled}
          readOnly={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChangeInput}
          onClick={() => {
            if(searchOnClick) {
              setOpen(true);
              onClickSearchIcon();
            }
          }}
        />
        {isSelected ? (
          <Styled.ContainerIconClose
            isOportunity={isOportunity}
            disabled={disabled}
          >
            <AiOutlineCloseCircle
              onClick={disabled ? () => {} : onChangeIcon}
            />
          </Styled.ContainerIconClose>
        ) : (
          <Styled.ContainerIcon
            onClick={handleSearchIconClick}
            disabled={disabled}
          >
            <BiSearch />
          </Styled.ContainerIcon>
        )}
      </Styled.SelectButton>

      {open && (
        <Styled.ListItems
          width={width}
          height={height}
          isOpen={disabled ? false : open}
        >
          {loading ? (
            <Styled.ContainerLoading>
              <Spinner />
            </Styled.ContainerLoading>
          ) : (
            <>{children}</>
          )}
        </Styled.ListItems>
      )}
    </Styled.Container>
  );
};

export default InputSelectSearch;
